// extracted by mini-css-extract-plugin
export var firstGlow = "styles-module--first-glow--1eed4";
export var item = "styles-module--item--0fc27";
export var itemText = "styles-module--item-text--f90ca";
export var itemTitle = "styles-module--item-title--4fc29";
export var list = "styles-module--list--28563";
export var subtitle = "styles-module--subtitle--a7964";
export var title = "styles-module--title--554bd";
export var wrapper = "styles-module--wrapper--4f812";